import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { AbstractToggler } from '@lt/components';
import withMobile from '../hocs/withMobile';

import { FatBlockContainer } from './ContentContainer';
import { CDN_ASSETS } from '../../../constants/common';

const palmImg = `${CDN_ASSETS}/gift/palm-with-shadow-mobile.png`;

const CertificateFaq = ({ items, isMobile, className }) => {
  // eslint-disable-next-line no-use-before-define
  const Wrapper = isMobile ? MobileWrapper : DesktopWrapper;
  return (
    <Wrapper className={className}>
      <StyledTitle isMobile={isMobile}>
        Как пользоваться сертификатом
      </StyledTitle>
      <StyledContainer>
        {items.map(({ question, answer }, idx) => (
          <StyledQuestion
            key={idx} // eslint-disable-line react/no-array-index-key
            label={question}
            isMobile={isMobile}
          >
            <StyledAnswer isMobile={isMobile}>{answer}</StyledAnswer>
          </StyledQuestion>
        ))}
      </StyledContainer>
      {isMobile && <StyledPalm />}
    </Wrapper>
  );
};

const DesktopWrapper = styled.div`
  min-height: 300px;
`;

const MobileWrapper = styled(FatBlockContainer)`
  position: relative;
  margin: 10px 0;
  padding: 10px;
  padding-bottom: 140px;
  overflow: hidden;
  background: #fcf4e8;
  border-radius: 6px;

  &::after {
    position: absolute;
    right: -45px;
    bottom: -75px;
    width: 146px;
    height: 100px;
    content: '';
    background-image: linear-gradient(
      23deg,
      #008ec9 4%,
      #2ec5e5 35%,
      #b9f2ff 83%
    );
    transform: rotate(160deg);
    filter: blur(29px);
  }
`;

const StyledPalm = styled.img.attrs({ src: palmImg })`
  position: absolute;
  bottom: 0;
  left: -30px;
  width: 125px;
  transform: scaleX(-1) rotate(-25deg);
`;

const StyledTitle = styled.h3`
  margin-bottom: 15px;
  font-size: 22px;
  font-weight: normal;
  color: ${(props) => props.theme.colors.blackBase};

  ${(props) =>
    props.isMobile &&
    css`
      margin-bottom: 20px;
      font-size: 18px;
    `}
`;

const StyledQuestion = styled(AbstractToggler)`
  padding-bottom: 15px;
  font-size: 14px;
  color: ${(props) => props.theme.colors.blackLight};

  ${(props) =>
    props.isMobile &&
    css`
      font-size: 13px;
      color: ${props.theme.colors.blackBase};
    `}
`;

const StyledContainer = styled.div`
  font-size: 14px;
  color: ${(props) => props.theme.colors.blackBase};
`;

const StyledAnswer = styled.div`
  padding-top: 10px;
  padding-bottom: 5px;
  font-size: 14px;
  white-space: pre-line;
  color: ${(props) => props.theme.colors.blackBase};

  ${(props) =>
    props.isMobile &&
    css`
      font-size: 13px;
      color: ${props.theme.colors.blackLight};
    `}
`;

CertificateFaq.propTypes = {
  className: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      question: PropTypes.string.isRequired,
      answer: PropTypes.string.isRequired,
    }),
  ).isRequired,
  isMobile: PropTypes.bool,
};
CertificateFaq.defaultProps = {
  className: '',
  isMobile: false,
};

export default React.memo(withMobile(CertificateFaq));
